import { isEqual } from "lodash";

export const getPostcodeWithTheSameRoutes = ({
  postcode,
  level,
  matrixTemplate,
  type
}) => {
  const line = matrixTemplate.filter(m => {
    if (level === 0) {
      return m.outer === postcode && m.sector === "";
    } else if (level === 1) {
      return m.sector === postcode && m.sector_plus1 === "";
    } else if (level === 2) {
      return m.sector_plus1 === postcode && m.postcode === "";
    } else {
      return m.postcode === postcode;
    }
  });

  if (!line[0]) {
    return [];
  }

  const matchingPostcodes = matrixTemplate.filter(
    m =>
      isEqual(m[type], line[0][type]) &&
      ((level === 0 && m.sector === "" && m.outer !== line[0].outer) ||
        (level === 1 &&
          m.sector_plus1 === "" &&
          m.sector !== "" &&
          m.sector !== line[0].sector) ||
        (level === 2 &&
          m.postcode === "" &&
          m.sector_plus1 !== "" &&
          m.sector_plus1 !== line[0].sector_plus1) ||
        (level === 3 && m.postcode !== line[0].postcode))
  );
  return matchingPostcodes.map(
    i => i.postcode || i.sector_plus1 || i.sector || i.outer
  );
};
